import { FormItemProps, Select as AntdSelect, SelectProps, Form } from "antd";
import React, { useMemo } from "react";
import "./styles.css";
import { Option } from "antd/es/mentions";
import { DownOutlined } from "@ant-design/icons";

// TODO: Implement generic prop type object type item support
interface Props<T> extends SelectProps {
  items: T[];
  getOptionLabel: (item: T) => JSX.Element;
  valueKey?: keyof T;
  isOptionDisabled?: (item: T) => boolean;
}

export const Select = <T,>({
  disabled,
  items,
  getOptionLabel,
  valueKey,
  isOptionDisabled,
  ...selectProps
}: Props<T>) => {
  const mappedOptions = useMemo(() => {
    return items?.map((item: T, index) => (
      <Option
        value={valueKey ? `${item[valueKey]}` : `${item}`}
        key={`${index}`}
        disabled={isOptionDisabled?.(item)}
      >
        {getOptionLabel?.(item) ?? `${item}`}
      </Option>
    ));
  }, [getOptionLabel, isOptionDisabled, items, valueKey]);

  return (
    <AntdSelect
      rootClassName={"select-root"}
      className={"select__selected-item"}
      size={"middle"}
      disabled={disabled || mappedOptions?.length <= 1}
      {...selectProps}
      suffixIcon={<DownOutlined />}
    >
      {mappedOptions}
    </AntdSelect>
  );
};

export const SelectField = <T,>({
  name,
  rules,
  style,
  hidden,
  label,
  required,
  ...selectProps
}: Props<T> &
  Pick<
    FormItemProps,
    "name" | "rules" | "style" | "hidden" | "label" | "required"
  >) => (
  <Form.Item
    name={name}
    rules={rules}
    style={style}
    hidden={hidden}
    label={label}
    required={required}
  >
    <Select {...selectProps} />
  </Form.Item>
);
